import { ROLE, SUB_ROLE } from "../../utils/constants/profiles";
import { generateAdminRoutes } from "./generateAdminRoutes";
import { generateBusinessRoutes } from "./generateBusinessRoutes";
import { generateOperatorRoutes } from "./generateOperatorRoutes";
import { generateUserRoutes } from "./generateUserRoutes";

export const generateDynamicProtectedRoutes = (role, appConfig) => {
  switch (role) {
    case ROLE.ADMIN:
      return generateAdminRoutes(appConfig);
    case ROLE.BUSINESS:
      return generateBusinessRoutes(appConfig);
    case SUB_ROLE.OPERATOR:
      return generateOperatorRoutes(appConfig);
    case ROLE.USER:
      return generateUserRoutes(appConfig);
    default:
      return [];
  }
};
